import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContentComponent } from '../../components/content/content.component';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [
    RouterModule,
    ContentComponent
  ],
  templateUrl: './not-found.component.html',
  styles: `p {
  padding-top: 100px;
  padding-bottom: 100px;
  display: block;
  text-align: center;
  font-size: 2rem;
  }
  `
})
export class NotFoundComponent {
  constructor() {
  }
}
